// ⭐ URL de la landing pública (arreglo del login en producción, 2026-08-17).
//
// App.js y utils/apiClient.js tenían cada uno su propia copia de
// `process.env.REACT_APP_LANDING_URL || 'http://localhost:5173'`. Es la misma
// trampa que con la URL de la API: el valor se congela en el build, así que un
// despliegue sin la variable manda a TODOS los usuarios a su propio
// localhost:5173 en dos situaciones bastante comunes —
//
//   · entrar al POS sin sesión (App.js redirige a la landing para iniciarla);
//   · que el token expire a mitad de uso (apiClient lo hace ante un 401).
//
// En ambos casos el usuario acaba en una página que no carga, justo después de
// hacer algo tan normal como abrir la aplicación o volver tras un rato.
//
// Se unifica aquí para que exista un solo sitio donde corregirlo, y el valor
// por defecto depende de dónde se está sirviendo la página en vez de asumir
// que siempre es una máquina de desarrollo.
const PRODUCTION_LANDING_URL = 'https://marketos.click';
// La landing comercial actual usa Vite y se sirve en el puerto 5173.
const LOCAL_LANDING_URL = 'http://localhost:5173';

const isLocalHost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

const LANDING_URL = process.env.REACT_APP_LANDING_URL
  || (isLocalHost ? LOCAL_LANDING_URL : PRODUCTION_LANDING_URL);

export default LANDING_URL;
